import React, { Component } from 'react';

class YesNo extends Component {
    render() {
        const {value} = this.props;

        return (
            <span>
                { value ? 'Ja' : 'Nee' }
            </span>
        );
    }
}

export default YesNo;


// WEBPACK FOOTER //
// ./src/shared/YesNo.js